import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Star, Clock, Heart, BadgeCheck, Zap } from 'lucide-react';

const TYPE_LABELS = { venue: 'ملعب', equipment: 'معدات', service: 'خدمة' };
const TYPE_COLORS = {
  venue: 'bg-blue-500/20 text-blue-400',
  equipment: 'bg-orange-500/20 text-orange-400',
  service: 'bg-purple-500/20 text-purple-400'
};

export default function ListingCard({ listing, onFavorite, isFavorited }) {
  const imgUrl = listing.primary_image
    ? `${process.env.REACT_APP_API_URL?.replace('/api', '')}${listing.primary_image}`
    : 'https://images.unsplash.com/photo-1459865264687-595d652de67e?w=400&h=250&fit=crop';

  return (
    <div className="card-hover bg-dark-800 rounded-2xl overflow-hidden border border-dark-700 group">
      <div className="relative overflow-hidden">
        <img src={imgUrl} alt={listing.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500" />

        {/* Overlays */}
        <div className="absolute top-3 right-3 flex items-center gap-2">
          <span className={`badge ${TYPE_COLORS[listing.type] || 'bg-dark-700 text-dark-300'} text-xs`}>
            {TYPE_LABELS[listing.type] || listing.type}
          </span>
          {listing.is_featured && (
            <span className="badge bg-accent/20 text-accent text-xs flex items-center gap-1">
              <Zap size={10} /> مميز
            </span>
          )}
        </div>

        {onFavorite && (
          <button onClick={(e) => { e.preventDefault(); onFavorite(listing.id); }}
            className={`absolute top-3 left-3 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
              isFavorited ? 'bg-red-500 text-white' : 'bg-dark-900/70 text-dark-300 hover:text-red-400'
            }`}>
            <Heart size={14} fill={isFavorited ? 'white' : 'none'} />
          </button>
        )}
      </div>

      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-white font-semibold text-sm leading-snug line-clamp-2 flex-1">{listing.title}</h3>
          {listing.is_verified && <BadgeCheck size={16} className="text-primary-400 flex-shrink-0 mt-0.5" />}
        </div>

        <div className="flex items-center gap-1.5 text-dark-400 text-xs mb-3">
          <MapPin size={12} className="text-primary-400" />
          <span>{listing.city}</span>
          {listing.category_name_ar && (
            <><span className="text-dark-600">•</span><span>{listing.category_name_ar}</span></>
          )}
        </div>

        <div className="flex items-center justify-between">
          <div>
            <span className="text-primary-400 font-bold text-lg">{listing.price_per_hour}</span>
            <span className="text-dark-400 text-xs mr-1">درهم/ساعة</span>
          </div>

          <div className="flex items-center gap-3">
            {listing.rating_count > 0 && (
              <div className="flex items-center gap-1 text-xs text-dark-400">
                <Star size={12} className="text-accent fill-accent" />
                <span className="text-white">{parseFloat(listing.rating_avg).toFixed(1)}</span>
                <span>({listing.rating_count})</span>
              </div>
            )}
            <Link to={`/listings/${listing.uuid || listing.id}`}
              className="bg-primary-600 hover:bg-primary-500 text-white text-xs px-3 py-1.5 rounded-lg transition-colors font-semibold">
              احجز الآن
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
